import React from 'react'

import { useFAQArticles } from './use-faq-articles'
import Header from './header'
import QuestionList from './question-list'

const FAQPage = () => {
  const { articles, searchQuery, onSearchInput, onSearch, filtering, onSortSelect } =
    useFAQArticles()

  return (
    <>
      <Header
        searchQuery={searchQuery}
        onSearchInput={onSearchInput}
        onSearch={onSearch}
        filtering={filtering}
        onSortSelect={onSortSelect}
      />

      <QuestionList articles={articles} />
    </>
  )
}

export default FAQPage
